import { render, staticRenderFns } from "./recommendation-boxes.vue?vue&type=template&id=f9f84488"
import script from "./recommendation-boxes.vue?vue&type=script&lang=js"
export * from "./recommendation-boxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports